import Vue from 'vue'
import { mapState } from 'vuex'
import { ChartOptions } from 'chart.js'
import { sumBy } from 'lodash'
import DateAmountStatistic from '@/models-ts/salaryStatistic/DateAmountStatistic'
import { RootState } from '@/store'
import { formatUsd, nFormatter } from '@/utils/moneyFormat'

export default Vue.extend<any, any, any, any>({
  computed: {
    ...mapState<RootState>({
      trends: (state: RootState) => state.salary.salaryData.value.trends,
    }),
    chartData() {
      return this.trends.map((trend: DateAmountStatistic) => ({ ...trend, title: trend.date }))
    },
    chartOptions() {
      return {
        plugins: {
          tooltip: {
            displayColors: false,
            callbacks: {
              label: (item) => `$${formatUsd(item.raw as string)}`,
            },
          },
        },
        scales: {
          yAxes: {
            ticks: {
              callback: (value: string) => nFormatter(value, 0),
            },
          },
        },
      } as ChartOptions
    },
    avgSalary() {
      return formatUsd(Math.floor(sumBy(this.trends, (trend: DateAmountStatistic) => trend.value) / this.trends.length))
    },
    dateChanged() {
      return `How Web3 salary has changed in ${this.trends[0].date} - ${this.trends[this.trends.length - 1].date}:`
    },
  },
  methods: {
    nFormatter,
  },
})
